export default function Contact() {
  return (
    <section id="contact" className="py-10 bg-white">
      <div className="max-w-md mx-auto px-4">
        <h2 className="text-xl font-bold text-gray-800 text-center mb-2">アクセス</h2>
        <p className="text-gray-600 text-sm text-center mb-8">お気軽にご来院ください</p>

        <div className="space-y-2 mb-4">
          <div className="flex items-start gap-2">
            <i className="ri-map-pin-line text-orange-500 text-lg flex-shrink-0 mt-0.5 w-5 h-5 flex items-center justify-center"></i>
            <div>
              <p className="font-semibold text-gray-800 text-sm">ねこのせなか整体院</p>
              <p className="text-gray-600 text-sm">〒277-0005 千葉県柏市柏3‐5‐14 永江ビル102</p>
            </div>
          </div>
          <div className="flex items-start gap-2">
            <i className="ri-train-line text-orange-500 text-lg flex-shrink-0 mt-0.5 w-5 h-5 flex items-center justify-center"></i>
            <p className="text-gray-600 text-sm">柏駅東口より徒歩7分</p>
          </div>
          <div className="flex items-start gap-2">
            <i className="ri-time-line text-orange-500 text-lg flex-shrink-0 mt-0.5 w-5 h-5 flex items-center justify-center"></i>
            <div>
              <p className="text-gray-600 text-sm">営業時間：10:00〜21:00（年中無休）</p>
              <p className="text-gray-500 text-xs">※研修などで不定期にお休みをいただく場合があります</p>
            </div>
          </div>
          <div className="flex items-start gap-2">
            <i className="ri-phone-line text-orange-500 text-lg flex-shrink-0 mt-0.5 w-5 h-5 flex items-center justify-center"></i>
            <a href="tel:04-7197-2992" className="text-gray-600 text-sm hover:text-orange-500 transition-colors cursor-pointer">
              04-7197-2992
            </a>
          </div>
        </div>
        <div className="rounded-xl overflow-hidden h-64">
          <iframe
            src="https://maps.google.com/maps?q=%E5%8D%83%E8%91%89%E7%9C%8C%E6%9F%8F%E5%B8%82%E6%9F%8F3-5-14+%E6%B0%B8%E6%B1%9F%E3%83%93%E3%83%AB102&t=m&z=17&ie=UTF8&iwloc=&output=embed&hl=ja"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="ねこのせなか整体院の地図"
          ></iframe>
        </div>
      </div>
    </section>
  );
}
